import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomerInfoContainer, { CustomerInfoContainerProps, CustomerInfoProps } from './containers/CustomerInfoContainer';

const CustomerInfo: React.FC<CustomerInfoContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    return (
        <CustomerInfoContainer {...containerProps} t={t} >
            {(props: CustomerInfoProps) => {
                return (
                    <React.Fragment>
                        <h4>Sr(a). {props.firstName + ' ' + props.lastName}</h4>
                        <ul className="no-bullet">
                            <li>
                                <span className="nome">{t('cards:customerInfo.address')}</span> <span className="valor">{props.address ? props.address : '–'}</span>
                            </li>
                            <li>
                                <span className="nome">{t('cards:customerInfo.addressNumber')}</span> <span className="valor">{props.addressNumber ? props.addressNumber : '–'}</span>
                            </li>
                            <li>
                                <span className="nome">{t('cards:customerInfo.addressFloor')}</span> <span className="valor">{props.addressFloor ? props.addressFloor : '–'}</span>
                            </li>

                            <li>
                                <span className="nome">{t('cards:customerInfo.postalCode')}</span> <span className="valor">{props.postalCode ? props.postalCode : '–'}</span>
                            </li>

                            <li>
                                <span className="nome">{t('cards:customerInfo.city')}</span> <span className="valor">{props.city ? props.city : '–'}</span>
                            </li>

                            <li>
                                <span className="nome">{t('cards:customerInfo.phoneNumber')}</span> <span className="valor">{props.phoneNumber ? props.phoneNumber : '–'}</span>
                            </li>
                        </ul>
                    </React.Fragment>
                );
            }}
        </CustomerInfoContainer>
    );
};

export default CustomerInfo;
